import React, { Component } from 'react';
import Webcam from 'react-webcam'
import Config from '../Config';
import VisitHistory from './VisitHistory';
import CheckItem from '../components/CheckItem';
import ServiceCallValidation from '../components/ServiceCallValidation';
import Accessories from '../components/Accessories';
import './css/summary.css'

class Summary extends Component {
    constructor(props) {
        super(props);

        this.webcamRef = React.createRef();

        this.state = {
            fullScreen: false,
            facingMode: "voorkant",
            testStarted: false,
            isFirstSave: props.current.isFirstSave,
            processRemark: props.changes.state.processRemark,
            videoConstraints: {

                facingMode: { exact: "environment" }
            },
            previousSaves: [],                        // already existing pictures, saved in possibly multiple times, even other serviceCalls
            pictures: this.props.changes.pictures,               // newly added pictures 
            mode: "",
            width: window.innerWidth,
            height: window.innerHeight
        };

        this.accessories = Accessories.getList();
    }
    componentDidMount() {

    }



    addPicture() {
        const pictureSrc = this.webcamRef.current.getScreenshot();
        if (!pictureSrc) return;
        const pictures = this.state.pictures;
        var newItem = { id: null, data: pictureSrc }

        this.setState({
            pictures: [...pictures, newItem]
        });
        this.closeFullScreen();
        this.props.changes.AddPicture(newItem);
    }
    closeFullScreen() {
        this.setState({
            mode: "", fullScreen: false, videoConstraints: {
                width: 400,
                height:  400,
                facingMode: this.state.videoConstraints.facingMode
            }
        });
    }

    deletePicture() {
        this.setState({ mode: "confirmDelete" });
    }
    deletePictureConfirmed() {
        var pictures = this.state.pictures;
        var itemToRemove = this.state.selectedPicture;

        if (itemToRemove.id) {
            // remove existing picture
            const requestOptions = Config.GetBearerDelete();
            fetch(Config.DigibonServiceBase + 'picture/' + itemToRemove.id, requestOptions)
                .then(response => {
                    if (response.ok) {
                        this.setState({ mode: "" });
                        this.initPictures(this.props.cardCode);
                    }
                })
        } else {
            // remove the "added" but not yet saved picture
            pictures = pictures.filter(p => p.data !== itemToRemove.data);
            this.setState({ pictures: pictures, mode: "" });

            // update the parent
            var deleteAtIndex = this.props.changes.pictures.find(p => p.data === itemToRemove.data);
            this.props.changes.pictures.splice(deleteAtIndex, 1)
        }
    }

    selectPicture(picture) {
        this.setState({ mode: "fotoview", selectedPicture: picture });
    }

    closeFotoView() {
        this.setState({ mode: "" });
    }
    fullScreen() {
        // toggle
        const currentlyFullScreen = this.state.fullScreen;
        this.setState({
            fullScreen: !currentlyFullScreen,
            mode: "fullscreenCapture",
            videoConstraints: {
                width: currentlyFullScreen ? 400 : window.innerWidth - 40,
                height: currentlyFullScreen ? 400 : window.innerHeight - 40,
                facingMode: this.state.videoConstraints.facingMode
            }
        });
    }

    toggleCamera() {
        if (this.state.facingMode === "gezicht") {
            this.setState({
                facingMode: "voorkant",
                videoConstraints: {
                    width: this.state.videoConstraints.width,
                    height: this.state.videoConstraints.height,
                    facingMode: { exact: "environment" }
                }
            });
        } else {
            this.setState({
                facingMode: "gezicht",
                videoConstraints: {
                    width: this.state.videoConstraints.width,
                    height: this.state.videoConstraints.height,
                    facingMode: "user"
                }
            });
        }
    }

    getChange(name) {
        const bon = this.props.current;
        const changes = this.props.changes.state;
        const bp = bon.serviceCall.businessPartner;
        var change = changes.accessories[name] - bp.productCountersRent[name];
        if (change > 0) return "+" + change;
        return change;
    }

    GetExistingImageSource(item) {
        return Config.DigibonServiceBase + "picture/" + item.id;
    }

    handleChange(evt) {
        const name = evt.target.id;
        const value = evt.target.value;
        this.setState({ [name]: value });
        this.props.changes.Set(name,value);  
    }

    
    render() {
        const changes = this.props.changes.state;
        
        var accesories =[];
        for (var item in changes.accessories) {
            var v=this.getChange(item);
            if (v!==0) {
                var label = `Wijziging ${item}: ${this.getChange(item)}`;
                accesories.push(<CheckItem key={item} value={true} label={label}></CheckItem>);
            }
            
        }

        // list of added products
        const products = changes.products && changes.products.map((item, index) => {
            return <div key={index}>Product {item.name} </div>
        });

        return <React.Fragment>
            <h4>Samenvatting - checklist</h4>



            {this.state.mode === "" && <div>



                <div className="row">
                    <div className="col-md">
                        { this.state.isFirstSave && (!changes.equipmentAdded || changes.equipmentAdded.length===0) &&
                            <CheckItem value={false} label={"Let op: er is geen enkele KEK toegevoegd"}></CheckItem>
                        }
                        { this.state.isFirstSave && ServiceCallValidation.skRequired(this.props.current.orders, this.props.changes) &&
                            <CheckItem value={false} label={"Let op: volgens de additionele producten moet er toegangsbeheer geinstalleerd worden."}></CheckItem>
                        }
                        {changes.changedCustomer != null &&
                            <CheckItem value={true} label={"Klant gegevens gewijzigd"}></CheckItem>
                        }
                        {changes.changedContactPersons.length>0 &&
                            <CheckItem value={true} label={"Contactpersonen gegevens gewijzigd (aantal: " + changes.changedContactPersons.length +  ")"}></CheckItem>
                        }
                        {changes.email != null &&
                            <CheckItem value={true} label={"Email gewijzigd: " + changes.email}></CheckItem>
                        }
                        {changes.iban != null &&
                            <CheckItem value={true} label={"IBAN gewijzigd: " + changes.iban}></CheckItem>
                        }
                        {changes.mbcode1 != null  &&
                            <CheckItem value={true} label={"Meldbank code deel 1 gewijzigd: " + (!changes.mbcode1 ? "[leeg]": changes.mbcode1)  }></CheckItem>
                        }
                        {changes.mbcode2 != null  &&
                            <CheckItem value={true} label={"Meldbank code deel 2 gewijzigd: " + (!changes.mbcode2 ? "[leeg]": changes.mbcode2) }></CheckItem>
                        }
                        {changes.emergencyCenter != null  &&
                            <CheckItem value={true} label={"Meldcentrale gewijzigd: " + changes.emergencyCenter }></CheckItem>
                        }
                        
                        
                        {changes.equipmentAdded && 
                            changes.equipmentAdded.filter(p=> !p.error).map((item, idx) => {
                                var label = item.item.isHomeAccess ?
                                    `Woningtoegang geïnstalleerd, KEK: ${item.number}` :
                                    `Personenalarm geïnstalleerd, KEK: ${item.number}`;
                                return <div key={idx}>
                                    <CheckItem value={true} label={label}></CheckItem>
                                </div>
                            })

                        }
                        {changes.equipmentRemoved &&
                            changes.equipmentRemoved.map((item, idx) => {
                                var label = item.item.isHomeAccess ?
                                    `Woningtoegang teruggenomen, KEK: ${item.number}` :
                                    `Personenalarm teruggenomen, KEK: ${item.number}`;
                                return <div key={idx}>
                                    <CheckItem value={true} label={label}></CheckItem>
                                </div>
                            })

                        }
                        {this.props.changes.state.processRemark &&
                            <CheckItem value={true} label="Algemene opmerking toegevoegd"></CheckItem>
                        }
                        
                        {this.props.changes.state.equipmentAdded && this.props.changes.state.equipmentAdded.filter(p => !p.item.isHomeAccess).length > 0 &&
                            <CheckItem value={this.props.changes.state.testSeconds > 0} label="Test uitgevoerd"></CheckItem>
                        }

                        {Object.keys(this.props.changes.state.accessories).length > 0 &&
                            <CheckItem value={true} label="Accessoires geinstalleerd"></CheckItem>
                        }

                        {this.props.changes.state.equipmentAdded && this.props.changes.state.equipmentAdded.length > 0 &&
                            <CheckItem value={this.props.changes.state.resolution} label="Werkzaamheden beschreven"></CheckItem>
                        }
                        
                        {this.props.changes.state.equipmentAdded && this.props.changes.state.equipmentAdded.filter(p => !p.item.isHomeAccess && !p.item.isMobile).length > 0 &&
                            <CheckItem value={this.props.changes.state.pstnInstalled!==null} label="Type PA installatie opgegeven"></CheckItem>
                        }
                        {this.props.changes.state.equipmentAdded && this.props.changes.state.equipmentAdded.filter(p => p.item.isHomeAccess).length > 0 &&
                            <CheckItem value={this.props.changes.state.keyPlaced>0} label="Sleutel achtergelaten opgegeven"></CheckItem>
                        }

                            {/* Er wordt een mail naar de klant verstuurd */}
                        {accesories}
                        {products && <React.Fragment><b>Toegevoegde artikelen:</b>{products}</React.Fragment>}

                        <h4 className="mt-4">Foto's</h4>


                        <Webcam
                            audio={false}
                            ref={this.webcamRef}
                            screenshotFormat="image/jpeg"
                            videoConstraints={this.state.videoConstraints}
                            onClick={this.addPicture.bind(this)}
                        />
                        <div className="row">
                            <div className="col">
                                <button className="btn btn-secondary" onClick={this.toggleCamera.bind(this)}><i className="fa-solid fa-shuffle"></i> &#160; toggle ({this.state.facingMode})</button><br/>
                                <button className="btn btn-secondary mt-2" onClick={this.fullScreen.bind(this)}><i className="fa-solid fa-magnifying-glass"></i> &#160; zoom </button>
                            </div>
                            <div className="col">                        <button onClick={(e) => {
                                e.preventDefault()
                                this.addPicture()
                            }}
                                className="btn btn-primary ms-4">
                                <i className="fa-solid fa-camera"></i> &#160; Maak foto
                            </button></div>
                        </div>


                    </div>
                    
                    <div className="col-md">
                        <VisitHistory cardCode={this.props.current.serviceCall.businessPartner.cardCode}></VisitHistory>

                        <label>Algemene opmerking (optioneel)</label>
                        <textarea className="form-control" id="processRemark" onChange={this.handleChange.bind(this)} value={this.state.processRemark ?? "" }></textarea>

                        <div>Totaal {this.state.pictures.length} nieuwe foto(s).

                        </div>

                        {this.state.pictures.map((item, index) => {
                            return <div className="thumbnail img-container" key={index}>
                                <img src={item.data} alt={"webcam image " + index} onClick={() => this.selectPicture(item)} />
                            </div>
                        }
                        )}

                    </div>
                

                </div>



            </div>
            }
            {this.state.mode === "fullscreenCapture" &&
                <div>
                    <div className="message-back"></div>
                    <Webcam
                        audio={false}
                        style={{ position: "fixed", top: 20, left: 20,objectFit:"contain" }}
                        ref={this.webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={this.state.videoConstraints}
                        onClick={this.addPicture.bind(this)}
                    />

                    <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.closeFullScreen.bind(this)}>
                        <i className="fa-sharp fa-solid fa-xmark"></i>
                    </button>
                </div>
            }
            {this.state.mode === "fotoview" && <div>
                <div className="picture-back"></div>

                <div className="picture-front">
                    
                            <img style={{width:"100%",height:"100%",objectFit:"contain", overflow:"clip"}} src={this.state.selectedPicture.id ?
                                this.GetExistingImageSource(this.state.selectedPicture) :
                                this.state.selectedPicture.data} alt="zoomed"></img>
                    

                    <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.closeFotoView.bind(this)}>
                        <i className="fa-sharp fa-solid fa-xmark"></i>
                    </button>

                    <button className="btn btn-danger sticky-bottom position-absolute start-0 ms-2 mb-2" onClick={this.deletePicture.bind(this)}>verwijder</button>
                </div>
            </div>
            }
            {this.state.mode === "confirmDelete" &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        <p>Plaatje verwijderen ?</p>

                        <button className="btn btn-secondary" onClick={p => this.setState({ mode: "" })}>annuleren</button>
                        <button className="ms-2 btn btn-primary" onClick={p => this.deletePictureConfirmed()}>bevestigen</button>
                    </div>
                </div>
            }



        </React.Fragment>

    }
}


export default Summary;